import React, { VFC } from 'react';
import { Link } from 'gatsby';

import { Button } from 'src/components/common/atoms';

type Props = {
  to: string;
  title: string;
  bg?: string;
};

const Component: VFC<Props> = ({ to, title, bg = 'var(--color-secondary-light)' }) => (
  <Link to={to}>
    <Button bg={bg}>{title}</Button>
  </Link>
);

export default Component;
